import { Type } from 'class-transformer';
import {
	StudentEnrollmentActivationItemModel,
	StudentEnrollmentActivationItemModel_ClassTransform_Type,
} from '../student-enrollment-activation-item.model';
import {
	ReentryInstituteModel,
	ReentryInstituteModel_ClassTransform_Type,
} from './re-entry-request.model';

export class ReentryRequirementsResponseModel {
	@Type(ReentryInstituteModel_ClassTransform_Type)
	target_institute: ReentryInstituteModel;
	@Type(StudentEnrollmentActivationItemModel_ClassTransform_Type)
	requirements: StudentEnrollmentActivationItemModel[];
}
